import { createApp } from "vue";
import VueDOMPurifyHTML from "vue-dompurify-html";
import "@ntprsrf-frontend/common/src/styles/index.scss"
import "customs-ui/styles";
import "./styles/index.scss";
import App from "./App.vue";
import router from "./routes";
import store from "./stores";
import {
  normalizeRequestInterceptor,
  handleErrorInterceptor,
  credentialInterceptor,
  setErrorNotification,
} from "@ntprsrf-frontend/common/src/utils/axios";
import useNotification from "@ntprsrf-frontend/common/src/components/NtpToast";
import { i18nextInitialized } from "./utils/localization";
import i18next from "i18next";
import I18NextVue from "i18next-vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { createHead } from '@unhead/vue/client';
import { register } from 'swiper/element/bundle';

import 'swiper/css';

import 'swiper/css/pagination';
import 'swiper/css/grid';

const app = createApp(App);
const head = createHead();
const errorNotification = useNotification("danger");

register();
setErrorNotification(errorNotification);
normalizeRequestInterceptor();
handleErrorInterceptor();
credentialInterceptor();

await i18nextInitialized;

app
  .use(store)
  .use(router)
  .use(VueDOMPurifyHTML)
  .use(VueReCaptcha, {
    siteKey: import.meta.env.VITE_CAPTCHA_KEY,
    loaderOptions: {},
  })
  .use(I18NextVue, { i18next })
  .use(head)
  .mount("#app");
